
import { routeBack } from '@/components/SharedViews/BackButton.vue';
import { component } from '@/helpers/vueTyped';

interface DialogProps {
  title?: string;
  message?: string;
  hasRetry?: boolean;
  retryCallback?: () => void;
}

export default component<DialogProps>()({
  name: 'Dialog',

  props: {
    title: { default: 'Sorry, something went wrong' },
    message: { default: 'We have encountered a problem. Please retry or try again later.' },
    retryCallback: {
      default: () => null,
    },
    hasRetry: {
      default: false,
    },
  },

  methods: {
    focus() {
      this.hasRetry
        ? (this.$refs.retryButton as HTMLElement).focus()
        : (this.$refs.backButton as HTMLElement).focus();
    },

    handleLeftNavigation() {
      this.hasRetry
        ? (this.$refs.retryButton as HTMLElement).focus()
        : (this.$refs.backButton as HTMLElement).focus();
    },

    handleRightNavigation() {
      (this.$refs.backButton as HTMLElement).focus();
    },
  },

  mounted() {
    this.focus();
    this.$spatialFocus.pushGlobalOverride('up', () => true);
    this.$spatialFocus.pushGlobalOverride('down', () => true);
    this.$spatialFocus.pushGlobalOverride('left', this.handleLeftNavigation);
    this.$spatialFocus.pushGlobalOverride('right', this.handleRightNavigation);
  },
  destroyed() {
    this.$spatialFocus.popGlobalOverride('up');
    this.$spatialFocus.popGlobalOverride('down');
    this.$spatialFocus.popGlobalOverride('left');
    this.$spatialFocus.popGlobalOverride('right');
  },

  render() {
    return (
      <div
        onFocus={this.focus}
        class='dialog-overlay'
      >
        <div class='title'>{this.title}</div>
        <div class='message'>{this.message}</div>
        <div class='dialog-buttons' v-spatial-container>
          {this.hasRetry && (
            <div
              ref='retryButton'
              class='dialog-button'
              onClick={this.retryCallback}
            >
              <div>Retry</div>
            </div>
          )}
          <div
            ref='backButton'
            class='dialog-button'
            onClick={() => routeBack()}
          >
            <span>Back</span>
          </div>
        </div>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-e8a5d3aa/Dialog.vue" });